<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="dataSource"
			:server-items-length="totalItens"
			item-key="id"
			no-data-text="O histórico não aparece"
			hide-default-footer
		>
			<template #item.quantidadeAditada="{ item }">
				<span class="pr-2">
					{{ item.quantidadeAditada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.dataCadastro="{ item }">
				<span>{{ item.dataCadastro | formatDataHourMinuteFilter }}</span>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@resetar-page="resetarPage"
			@paginar="setPaginacaoHistorico"
		></paginacao-tabela>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import { mapState } from 'vuex'

export default {
	name: 'historico-transferencia',
	components: {},
	props: {},
	data() {
		return {
			dataSource: [],
			colunas: [
				new TabelaColunaUtils('Saldo transferido', 'quantidadeAditada', '15%'),
				new TabelaColunaUtils('Órgão Anterior', 'orgaoAnterior', '15%'),
				new TabelaColunaUtils('Órgão Atual', 'orgaoAtual', '15%'),
				new TabelaColunaUtils('Justificativa', 'justificativa', '19%'),
				new TabelaColunaUtils('Data', 'dataCadastro', '15%'),
				new TabelaColunaUtils('Usuário', 'usuario', '15%'),
			],
			paginacaoInterna: PaginacaoListagem(['id'], 5, 'DESC'),
			totalPaginas: 0,
			totalItens: 0,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
		}),
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.RESETAR_PAGINA_LISTAGEM)
	},
	async mounted() {
		await this.carregarHistoricos()
	},
	methods: {
		async carregarHistoricos() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.BUSCAR_HISTORICO_TRANSFERENCIA,
				this.itemSelecionado.id,
			)
			this.dataSource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.carregando = false
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.carregarHistoricos()
		},
	},
}
</script>
<style lang="stylus" scoped></style>
